/* eslint-disable max-lines */
import React, { Component } from "react";
import { Button, Divider } from "antd";

import {
  generateUUID,
  checkEmptyObject,
  isObject
} from "../../../services/utils";
import { MultiLevelSelector } from "../MultiLevelSelector";
import styles from "./multiLevelSelectList.scss";
import { getIconUrl } from "../../../services/asset";

class MultiLevelSelectList extends Component {
  constructor(props) {
    super(props);

    const { isSingleElement, child, value } = props;

    if (isSingleElement) {
      this.state = { children: [{ id: generateUUID() }] };
    } else if (!checkEmptyObject(value)) {
      this.generateMinimumComtrols();
    } else {
      this.state = { children: [] };
    }

    this.getChildFields(child);
    this.injectSingleValue(value);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      if (checkEmptyObject(nextProps.value)) {
        this.injectSingleValue(nextProps.value);
      }
    }
  }

  generateMinimumComtrols = () => {
    const { minimum } = this.props;
    const childs = [];
    for (let i = 0; i < minimum; i += 1) {
      childs.push({ id: generateUUID() });
    }
    this.state = { children: childs };
  };

  getChildFields = child => {
    this.childFields.push(child.field);

    if (child.child) {
      this.getChildFields(child.child);
    }
  };

  childFields = [];

  handleChildValueChange = (childValue, childKey) => {
    const { children } = this.state;

    const child = children.find(c => c.id === childKey);
    child.value = childValue;
    this.emitChangeValue();
  };

  handleAddChildClick = () => {
    const { maxChildren } = this.props;
    const { children } = this.state;

    if (children.length == maxChildren) {
      return;
    }

    children.push({ id: generateUUID() });
    this.setState({ children });
  };

  handleRemoveChildClick = childKey => {
    const { children } = this.state;
    const { minimum } = this.props;

    let newChildren = [];

    if (children.length === 1 && minimum > 0) {
      newChildren = [{ id: generateUUID() }];
    } else {
      newChildren = children.filter(c => c.id !== childKey);
    }

    this.setState({ children: newChildren }, this.emitChangeValue);
  };

  injectSingleValue = value => {
    const { children } = this.state;

    if (checkEmptyObject(value) && children.length === 0) {
      isObject(value) &&
        Object.keys(value).forEach(key => {
          value[key].forEach(v => {
            const singleValue = {};
            singleValue[key] = v;

            children.push({
              id: generateUUID(),
              singleValue
            });
          });
        });
    }
  };

  emitChangeValue = () => {
    const { children } = this.state;
    const { onChange } = this.props;
    const value = {};

    children.forEach(c => {
      const childValue = c.value || c.singleValue;

      if (childValue) {
        isObject(childValue) &&
          Object.keys(childValue).forEach(key => {
            const index = this.childFields.indexOf(key);
            const childField = this.childFields[index + 1];

            if (!childValue[childField]) {
              const childId = childValue[key];

              if (value[key]) {
                if (!value[key].find(id => id === childId)) {
                  value[key].push(childId);
                }
              } else {
                value[key] = [childId];
              }
            }
          });
      }
    });

    onChange(checkEmptyObject(value));
  };

  // eslint-disable-next-line max-lines-per-function
  render() {
    const {
      title,
      child,
      dataSource,
      module,
      category,
      isSingleElement,
      isMultiRows,
      className,
      minimum,
      parentIds,
      addMoreText,
      addMoreIconName,
      wrapClassName,
      showPlaceholder,
      getPopupContainer
    } = this.props;
    const { children } = this.state;

    return (
      <div className={wrapClassName}>
        <div className={styles.title}>{showPlaceholder ? null : title}</div>
        {/* eslint-disable-next-line complexity */}
        {children.map((c, index) => (
          <div
            key={c.id}
            className={`${className} ${styles.control} ${
              isSingleElement ? styles.fullWidth : null
            }`}
          >
            <MultiLevelSelector
              child={child}
              dataSource={dataSource}
              module={module}
              category={category}
              value={c.value}
              singleValue={c.singleValue}
              parentId={c.id}
              onChange={this.handleChildValueChange}
              selectorClassName={!isMultiRows ? null : styles.selector}
              isMultiRows={isMultiRows}
              className={!isMultiRows ? null : styles.multiRowSelector}
              showPlaceholder={showPlaceholder}
              getPopupContainer={getPopupContainer}
            />

            {!isSingleElement &&
            (minimum === 0 ||
              (children.length === 1 && (c.value || c.singleValue)) ||
              children.length > 1) ? (
              <span
                role="button"
                tabIndex="0"
                className={styles.deleteIcon}
                onClick={() => this.handleRemoveChildClick(c.id, c.value)}
              >
                <img
                  alt={"Više"}
                  src={getIconUrl("garbage.svg")}
                />
              </span>
            ) : null}
            {!isSingleElement &&
            children.length > 1 &&
            index < children.length - 1 ? (
              <Divider className={styles.divider} />
            ) : null}
          </div>
        ))}
        {!isSingleElement ? (
          <Button
            type="default"
            icon={addMoreIconName}
            size="large"
            className={styles.addMore}
            onClick={this.handleAddChildClick}
          >
            {addMoreText}
          </Button>
        ) : null}
      </div>
    );
  }
}

MultiLevelSelectList.defaultProps = {
  title: "",
  isSingleElement: false,
  isMultiRows: false,
  onChange: () => null,
  className: "",
  minimum: 0,
  parentIds: [],
  addMoreText: "Dodaj",
  addMoreIconName: "plus",
  wrapClassName: ""
};

export default MultiLevelSelectList;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiLevelSelectList/MultiLevelSelectList.js